// removed by extract-text-webpack-plugin
module.exports = {"descriptionText":"LandingDescription_descriptionText_2RMXd","descriptionWord":"LandingDescription_descriptionWord_1qS5Q","qrCode":"LandingDescription_qrCode_TAGkh"};